import PropTypes from 'prop-types';

import Container, { ContainerProps as ContainerProps } from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { Box, Stack, Typography } from '@mui/material';
import { Divider } from '@classity-edtech/ui-base';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import ExternalLink from '../../../components/ExternalLink';
import { LinkedInIcon } from '@classity-edtech/ui-base/dist/components/Displays';

export interface CompanyProps extends ContainerProps {
  title: string;
  description: string;
  list: string[];
  imageUrl: string;
  testimony: {
    testimony: string;
    name: string;
    title: string;
    cta: string;
    ctaLink: string;
  };
}

export const Company = ({
  className,
  title,
  description,
  list,
  imageUrl,
  testimony,
  ...props
}: CompanyProps) => {
  return (
    <Box sx={{ background: globalColours['$global-colour-background-neutral-default'] }}>
      <Container
        className={className}
        sx={{
          minHeight: { xs: 'max-content', md: '100vh' },
          py: 8,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: { xs: 4, md: 13 },
          }}
        >
          <Stack sx={{ gap: 1.5 }}>
            <Typography variant='subtitle2'>{title}</Typography>
            <Typography variant='body2SemiBold'>{description}</Typography>
            {list?.map((l, index) => (
              <Typography key={index} variant='body2'>
                {l}
              </Typography>
            ))}
          </Stack>

          <Box
            component='img'
            sx={{
              width: '100%',
              borderRadius: '30px',
            }}
            alt=''
            src={imageUrl}
          />
        </Box>
        <Divider sx={{ my: 6 }} />
        <Typography variant='subtitle4' sx={{ textAlign: 'center', display: 'block' }}>
          {testimony?.testimony}
        </Typography>
        <Stack sx={{ alignItems: 'center', mt: 2 }}>
          <Typography variant='body2SemiBold'> {testimony?.name}</Typography>
          <Typography variant='body2'> {testimony?.title}</Typography>
          <ExternalLink
            target='_blank'
            cta={testimony?.cta}
            href={testimony?.ctaLink}
            icon={<LinkedInIcon sx={{ width: '16px', height: '16px' }} />}
          />
        </Stack>
      </Container>
    </Box>
  );
};

Company.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Company.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(Company)(
  ({ theme }) => `
  &.MuiBox-root {
  }
`,
);
